/**
 * The league id for a league key, read from the league catalog the Squares
 * screens already load (react-query shares the one catalog read). Null until
 * the catalog answers or when the key is unknown. ISSUE-1275, ISSUE-1266.
 */
import { useLeagueCatalogGet } from "@sportsmet/sports-sdk/private";
import { useMemo } from "react";

const CATALOG_STALE_TIME_MS = 5 * 60 * 1000;

export function useSquaresLeagueId(leagueKey: string | null): string | null {
  const catalog = useLeagueCatalogGet({}, { staleTime: CATALOG_STALE_TIME_MS });
  return useMemo(() => {
    if (leagueKey === null) return null;
    for (const sport of catalog.data?.data?.sports ?? []) {
      const found = sport.leagues.find(
        (candidate) => candidate.leagueKey === leagueKey,
      );
      if (found) return found.leagueId;
    }
    return null;
  }, [catalog.data, leagueKey]);
}
